export default __webpack_public_path__ + "static/media/logo_savills.5569d77d.svg";